// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationGroupId } from './FermentationGroup';
import { fermentationProcedureProtocolId } from './FermentationProcedureProtocol';
import { fermentationProtocolId } from './FermentationProtocol';
import { operatorId } from './Operator';
import { z } from 'zod';
export const fermentationGroupProtocolOverrideId = (z.number());
export const fermentationGroupProtocolOverride = z.object({
    id: fermentationGroupProtocolOverrideId,
    group_id: fermentationGroupId,
    sequence_entry_id: fermentationProcedureProtocolId,
    protocol_id: fermentationProtocolId,
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
});
export const fermentationGroupProtocolOverrideInitializer = z.object({
    id: fermentationGroupProtocolOverrideId.optional(),
    group_id: fermentationGroupId,
    sequence_entry_id: fermentationProcedureProtocolId,
    protocol_id: fermentationProtocolId,
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
export const fermentationGroupProtocolOverrideMutator = z.object({
    id: fermentationGroupProtocolOverrideId.optional(),
    group_id: fermentationGroupId.optional(),
    sequence_entry_id: fermentationProcedureProtocolId.optional(),
    protocol_id: fermentationProtocolId.optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=FermentationGroupProtocolOverride.js.map